export default class Shared {
    static get_launcher() {
        return {};
    }

    static get_modules() {
        return [];
    }
}